import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  customDatePickerContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  customDatePickerWrapper: {
    alignItems: 'end',
    display: 'flex',
  },
  dateRangePicker: {
    width: 617,
    right: 0,
    position: 'absolute',
    marginTop: 10,
    // height: 687,
    backgroundColor: color.uiBackground,
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 4px 0px, rgba(0, 0, 0, 0.2) 0px 4px 8px 0px',
    borderRadius: '0.1875em',
    zIndex: 1000,
  },
  datesPrefix: {
    color: color.bodyText,
    fontSize: fontSize.bodyText,
    fontFamily: typography.bodyText,
    marginRight: 12,
  },
  filterContainer: {
    padding: '2%',
    textAlign: 'left',
  },
  dateRangeLabel: {
    color: color.pageTitle,
    fontSize: fontSize.title,
    fontFamily: typography.pageTitle,
  },
  filterTitle: {
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
    paddingBottom: 5,
    '@media print': {
      marginBottom: -20,
    },
  },
  customDates: {
    color: color.pageTitle,
    fontSize: fontSize.title,
    fontFamily: typography.pageTitle,
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  button: {
    margin: '10px 10px',
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontFamily: `${typography.bodyText} !important`,
    height: 40,

  },
  applyBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: fontSize.small,
    fontFamily: typography.buttonText,
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  smallLabel: {
    fontSize: fontSize.small,
    marginBottom: 11,
    color: 'red',
    align: 'right',
    '@media print': {
      marginBottom: 0,
    },
  },
  cancelBtn: {
    backgroundColor: `${color.primaryButtonText} !important`,
    color: `${color.primaryButtonBackground} !important`,
    fontFamily: typography.buttonText,
    fontSize: fontSize.small,
    borderColor: `${color.primaryButtonBackground} !important`,
    marginLeft: 0,
    '&:hover': {
      backgroundColor: colorMod(color.primaryButtonBackground).alpha(0.08).string(),
      borderColor: colorMod(color.primaryButtonBackground).alpha(0.08).string(),
    },
  },
  disableBtn: {
    pointerEvents: 'none',
    borderColor: colorMod(color.bodyText).alpha(0.05).string(),
    backgroundColor: colorMod(color.bodyText).alpha(0.05).string(),
    color: color.bodyText,
  },
  popupContainer: {
    display: 'inline-block',
    float: 'right',
    marginBottom: 10,
    position: 'relative',
  },
  popupBtn: {
    width: 'auto',
    background: color.primaryButtonText,
    border: `1px solid ${color.primaryButtonBackground}`,
    color: color.primaryButtonBackground,
    height: 32,
    fontFamily: `${typography.buttonText} !important`,
    fontSize: fontSize.buttonText,
    fontWeight: 'normal',
    borderRadius: 3,
    '& span': {
      textAlign: 'left',
    },
    '&:focus': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.primaryButtonBackground}`,
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '@media print': {
      display: 'none',
    },
  },
  largePopupBtn: {
    height: 40,
  },
  printDateRange: {
    display: 'none',
    '@media print': {
      display: 'flex',
      fontSize: 11,
      fontWeight: 'normal',
      fontFamily: `${typography.bodyText} !important`,
      textAlign: 'left',
    },
  },
  dropdownOpen: {
    transform: 'rotate(180deg)',

  },
  arrowBtn: {
    display: 'inline',
    color: color.primaryButtonBackground,
    fontSize: 11,
    float: 'right',
    margin: '0 5px',
    '@media print': {
      display: 'none',
      color: '#fff',
      fontSize: 11,
      float: 'right',
      margin: '0 5px',
    },

  },
  customRadioBtn: {
    '& span': {
      display: 'inherit !important',
      paddingLeft: '0 !important',
      cursor: 'pointer',
    },
  },
});
